import banks from '../data/kgsBanks.json';
export const KGS_BANKS = banks;
const key = (value: string) => value.toLowerCase().replace(/[\s!()._-]+/g, '');
export const kgsBankId = (value?: string | null): string | undefined => {
    if (!value) return undefined;
    return banks.find(bank => [bank.id, bank.name, ...bank.aliases].some(alias => key(alias) === key(value)))?.id;
};
export const bankDisplayName = (value?: string | null): string =>
    banks.find(bank => bank.id === kgsBankId(value))?.name || value || '';
